const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsProdutos = { name: 'Produtos', pathName: null, action: 'produtos' }
const breadcrumbsList = {
  name: 'Listagem',
  pathName: '/produtos/gerenciamento-produtos/produtos-loja',
}
export default [
  {
    path: '/produtos',
    component: () => import('@/modules/produtos/views/pages/Produtos.vue'),
    children: [
      {
        path: 'busca-produto',
        component: () => import('@/components/busca-detalhes/Busca.vue'),
        props: {
          searchType: 'produto',
        },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Busca de produto',
              pathName: null,
            },
          ],
          title: 'Busca de produto',
          pagePermission: 'produtos/busca_produto',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'detalhes-produto/:id',
        name: 'detalhes-produto',
        component: () => import('@/modules/produtos/detalhes-produto/views/pages/DetalhesProduto.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Busca de produto',
              pathName: '/produtos/busca-produto',
            },
            {
              name: 'Detalhes do produto',
              pathName: null,
            },
          ],
          title: 'Detalhes do produto',
          pagePermission: 'produtos/detalhes_produto',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'ranking-produtos',
        component: () => import('@/modules/produtos/ranking-produtos/views/pages/RankingProdutos.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Ranking de produtos',
              pathName: null,
            },
          ],
          title: 'Ranking de produtos',
          pagePermission: 'produtos/ranking_produtos',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'arvore-produtos',
        component: () => import('@/modules/produtos/arvore-produtos/views/pages/ArvoreProdutos.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Árvore de produtos',
              pathName: null,
            },
          ],
          title: 'Árvore de produtos',
          permission: 'products_tree',
          pagePermission: 'produtos/arvore_produtos',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'comparativo-produtos',
        component: () => import('@/modules/produtos/comparativo/views/pages/ComparativoDeProdutos.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Comparativo de produtos',
              pathName: null,
            },
          ],
          title: 'Comparativo de produtos',
          pagePermission: 'produtos/comparativo_produtos',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'comparativo-categorias',
        component: () => import('@/modules/produtos/comparativo-categorias/views/pages/ComparativoDeCategorias.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Comparativo de categorias',
              pathName: null,
            },
          ],
          title: 'Comparativo de categorias',
          pagePermission: 'produtos/comparativo_categorias',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'gerenciamento-produtos',
        title: 'Produtos',
        component: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/Gerenciamento.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Gerenciamento de produtos',
              pathName: null,
            },
          ],
          title: 'Produtos',
          allowOnlyMercapromo: true,
        },
        // TODO: Trocar pelo Gerenciamento de produtos ao finalizar integração
        children: [
          {
            path: '',
            component: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/GerenciamentoModulos.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsProdutos,
                {
                  name: 'Listagem',
                  pathName: null,
                },
              ],
              title: 'Produtos',
              allowOnlyMercapromo: true,
            },
          },
          {
            path: 'produtos-loja',
            component: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/GerenciamentoProdutosLoja.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsProdutos,
                {
                  name: 'Listagem',
                  pathName: null,
                },
              ],
              title: 'Produtos Loja',
              allowOnlyMercapromo: true,
            },
          },
          {
            path: 'grupos',
            title: 'Produtos',
            component: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/GerenciamentoGrupos.vue'),
            meta: {
              title: 'Produtos',
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsProdutos,
                {
                  name: 'Gerenciamento de produtos',
                  pathName: 'gerenciamento-produtos',
                },
              ],
              allowOnlyMercapromo: true,
            },
          },
        ],
      },
      {
        name: 'novo-produto',
        path: 'novo',
        title: 'Produto',
        component: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/createEditProduct/CreateEditProduct.vue'),
        meta: {
          title: 'Produto',
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Listagem',
              pathName: '/produtos/gerenciamento-produtos',
            },
            {
              name: 'Novo produto',
              pathName: null,
            },
          ],
          allowOnlyMercapromo: true,
        },
      },
      {
        name: 'alterar-produto',
        path: 'alterar/:id?',
        title: 'Produto',
        component: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/createEditProduct/CreateEditProduct.vue'),
        meta: {
          title: 'Produto',
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Listagem',
              pathName: '/produtos/gerenciamento-produtos',
            },
            {
              name: 'Editar produto',
              pathName: null,
            },
          ],
          allowOnlyMercapromo: true,
        },
      },
      {
        name: 'alterar-produto-loja',
        path: 'alterar-produto-loja/:id?',
        title: 'Produto',
        component: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/createEditProductStore/CreateEditProductStore.vue'),
        meta: {
          title: 'Produto',
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            breadcrumbsList,
            {
              name: 'Editar produto loja',
              pathName: null,
            },
          ],
          allowOnlyMercapromo: true,
        },
      },
      {
        name: 'novo-produto-loja',
        path: 'novo-produto-loja',
        title: 'Produto',
        component: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/createEditProductStore/CreateEditProductStore.vue'),
        meta: {
          title: 'Produto',
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            breadcrumbsList,
            {
              name: 'Novo produto loja',
              pathName: null,
            },
          ],
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'faixas-precos',
        component: () => import('@/modules/produtos/faixa-precos/views/pages/PriceRange.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Faixas de preços',
              pathName: null,
            },
          ],
          title: 'Faixas de preços',
          pagePermission: 'produtos/faixas_precos',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'faixas-precos/nova-analise',
        name: 'Nova análise',
        component: () => import('@/modules/produtos/faixa-precos/views/pages/NewAnalyse.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Faixas de preços',
              pathName: '/produtos/faixas-precos',
            },
            {
              name: 'Nova análise',
              path: null,
            },
          ],
          title: 'Nova análise',
          pagePermission: 'produtos/faixas_precos',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'faixas-precos/:id',
        name: 'Editar análise',
        component: () => import('@/modules/produtos/faixa-precos/views/pages/NewAnalyse.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsProdutos,
            {
              name: 'Faixas de preços',
              pathName: '/produtos/faixas-precos',
            },
            {
              name: 'Editar análise',
              path: null,
            },
          ],
          title: 'Editar análise',
          pagePermission: 'produtos/faixas_precos',
          allowOnlyMercapromo: true,
        },
      },
    ],
  },
]
